    import React from 'react';
    import SpinnerOverlay from "src/components/common/SpinnerOverlay";
    import PDAHeader from "src/components/common/Header";
    import usePDA1100_R01Store from "./usePDA1100_R01Store";
    import { usePDAContainer } from "src/hooks/usePDAContainer";
    import PDA1100_R01Info from "./PDA1100_R01Info";

    /**
     * PDA1100_R01 자재 저장위치 등록 메인 컨테이너
     * 
     * 기능:
     * - 품목코드/바코드/LOT번호 스캔으로 품목 정보 조회
     * - 새 저장위치 입력 후 mst_item.location_cd 수정
     * 
     * 화면 구성:
     * - 상단: 스캔 입력 + 품목 정보 표시
     * - 하단: 새 저장위치 입력 + 저장/취소 버튼
     */
    interface PDA1100_R01ContainerProps {
    menuNm: string;
    menuCd?: string;
    onBack?: () => void;
    }

    const PDA1100_R01Container = ({ 
    menuNm, 
    menuCd, 
    onBack 
    }: PDA1100_R01ContainerProps) => {
    const { loading, reset } = usePDA1100_R01Store();

    const { handleMenuClick } = usePDAContainer(reset);

    return (
        <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
        {/* 헤더 */}
        <PDAHeader 
            menuNm={menuNm} 
            menuCd={menuCd} 
            onBack={onBack} 
            onMenuClick={handleMenuClick} 
        />

        {/* 메인 콘텐츠 */}
        <div className="flex-1 overflow-y-auto">
            <PDA1100_R01Info />
        </div>

        {/* 로딩 스피너 */}
        {loading && <SpinnerOverlay text="처리 중..." />}
        </div>
    );
    };

    export default PDA1100_R01Container;
